import { Pipe, PipeTransform } from '@angular/core';
import { Duration } from 'luxon';

import { DurationInfo } from 'app/shared/models/duration-info.model';

/**
 * Converts a value in milliseconds or a luxon duration to its parts in days, hours, minutes, seconds
 *
 * @param value the duration length as a luxon Duration type or milliseconds (number)
 * @returns Returns the duration in days, hours, minutes, seconds rounded to their whole number floored values
 */
@Pipe({
  name: 'duration'
})
export class DurationPipe implements PipeTransform {
  public transform(value: Duration | number): DurationInfo {
    let duration = typeof value === 'number'
      ? Duration.fromMillis(value)
      : value;

    duration = duration.shiftTo('days', 'hours', 'minutes', 'seconds');

    return {
      days: Math.trunc(duration.days),
      hours: Math.floor(duration.hours),
      minutes: Math.floor(duration.minutes),
      seconds: Math.floor(duration.seconds)
    };
  }
}
